/* Tygrix cart drawer: instant feedback on add to cart, grouped line quantity/remove controls and upsell buttons.
   Loaded on every page so the controls work after the drawer is re-rendered.
   Shopify takes ~0.5-1s to change a cart, so the drawer opens and updates on screen straight away
   and catches up with the server response when it arrives. */

(function () {
  if (window.nxciReady) return;
  window.nxciReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = function () { return document.querySelector('cart-drawer'); };
  var loadingTimer;

  /* ---------- Loading state: open the drawer as soon as an add starts ---------- */
  function setLoading(on) {
    var d = drawer();
    if (!d) return;
    clearTimeout(loadingTimer);
    if (on) {
      d.classList.add('tx-cart-loading');
      if (typeof d.open === 'function' && !d.classList.contains('active')) d.open();
      loadingTimer = setTimeout(function () { setLoading(false); }, 10000);
    } else {
      d.classList.remove('tx-cart-loading');
    }
  }
  window.txCartLoading = setLoading;

  // Any re-render of the drawer means the server answered: drop the loading state.
  customElements.whenDefined('cart-drawer').then(function () {
    var C = customElements.get('cart-drawer');
    if (!C || C.prototype.__txPatched) return;
    var render = C.prototype.renderContents;
    C.prototype.renderContents = function (state) {
      var out = render.call(this, state);
      this.classList.remove('tx-cart-loading');
      return out;
    };
    C.prototype.__txPatched = true;
  });

  // Add-to-cart forms (bundle builders and the standard product form) all submit to /cart/add.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var owner = form.closest('nk-buybox, nx-buybox, product-form');
    // Only when the owner's script is running; otherwise the early-tap guard replays the submit later.
    if (!owner || !customElements.get(owner.localName)) return;
    setLoading(true);
  });
  document.addEventListener('tx:cart-error', function () {
    setLoading(false);
    var d = drawer();
    if (d && typeof d.close === 'function') d.close();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartError, function () { document.dispatchEvent(new CustomEvent('tx:cart-error')); });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartError, function () { document.dispatchEvent(new CustomEvent('tx:cart-error')); });
      }
    });
  }

  /* ---------- Quantity and remove: update on screen now, sync with Shopify after a short pause ---------- */
  var pending = {};   // row keys -> { target, timer }
  var inFlight = 0;

  function sectionsBody(body) {
    var d = drawer();
    if (d && d.getSectionsToRender) {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  function setSyncing() {
    var d = drawer();
    if (!d) return;
    var busy = inFlight > 0 || Object.keys(pending).length > 0;
    d.classList.toggle('tx-cart-syncing', busy);
    var checkout = d.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled = busy || d.classList.contains('nk-gift-syncing');
  }

  async function sync(keysStr) {
    var p = pending[keysStr];
    if (!p) return;
    delete pending[keysStr];
    var keys = keysStr.split(',');
    var updates = {};
    keys.forEach(function (k, i) { updates[k] = i === 0 ? p.target : 0; });
    // Free gifts that this change earns or loses go in the same request, so the drawer redraws once.
    var base = Object.assign({}, updates);
    var gifts = window.nkGifts && window.nkGifts.planFor(updates);
    if (gifts) Object.keys(gifts).forEach(function (id) { updates[id] = gifts[id]; });
    inFlight++;
    setSyncing();
    var post = function (u) {
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(sectionsBody({ updates: u })),
      });
    };
    try {
      var res = await post(updates);
      var data = await res.json();
      // A gift that can't be added (sold out, unpublished) must never block the bottles.
      if ((!res.ok || data.status) && gifts) {
        res = await post(base);
        data = await res.json();
      }
      if (!res.ok || data.status) throw new Error('error');
      inFlight--;
      // Only redraw once every change has been sent, so a newer tap isn't overwritten.
      if (inFlight === 0 && Object.keys(pending).length === 0) {
        var d = drawer();
        if (d && data.sections) {
          d.classList.toggle('is-empty', data.item_count === 0);
          d.renderContents(Object.assign({}, (data.items && data.items[0]) || {}, { sections: data.sections }));
        } else {
          window.location.reload();
        }
      }
    } catch (err) {
      window.location.reload();
      return;
    }
    setSyncing();
  }

  // Send any waiting +/- taps now and resolve once every quantity change has reached Shopify.
  window.nxciFlush = async function () {
    Object.keys(pending).forEach(function (k) { clearTimeout(pending[k].timer); sync(k); });
    for (var i = 0; i < 100 && (inFlight > 0 || Object.keys(pending).length > 0); i++) {
      await new Promise(function (r) { setTimeout(r, 50); });
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nxci-keys]');
    if (!btn) return;
    e.preventDefault();
    var keysStr = btn.dataset.nxciKeys;
    var row = btn.closest('li') || btn.parentElement;
    var shown = row && row.querySelector('.nxci__q span');
    var current = pending[keysStr] ? pending[keysStr].target : Number(shown ? shown.textContent : btn.dataset.nxciQty) || 0;
    var target;
    if (btn.classList.contains('nxci__del')) target = 0;
    else if (btn.getAttribute('aria-label') === 'Add one') target = current + 1;
    else if (btn.getAttribute('aria-label') === 'Remove one') target = Math.max(0, current - 1);
    else target = Math.max(0, Number(btn.dataset.nxciQty) || 0);

    if (shown) shown.textContent = target;
    if (row) row.classList.toggle('nxci--removing', target === 0);

    if (pending[keysStr]) clearTimeout(pending[keysStr].timer);
    pending[keysStr] = { target: target, timer: setTimeout(function () { sync(keysStr); }, target === 0 ? 0 : 350) };
    setSyncing();
  });
})();

(function () {
  if (window.nxcUpReady) return;
  window.nxcUpReady = true;
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-nxc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    if (window.txCartLoading) window.txCartLoading(true);
    if (window.nxciFlush) await window.nxciFlush();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    var item = { id: Number(btn.dataset.nxcAdd), quantity: Number(btn.dataset.nxcQty) || 1 };
    if (btn.dataset.nxcPlan) item.selling_plan = Number(btn.dataset.nxcPlan);
    var body = { items: [item] };
    var withGifts = false;
    // Bottles from an upsell bring their free gifts with them.
    if (!btn.dataset.nxcRemove && window.nkGifts && window.nkGifts.state()) {
      body.items = window.nkGifts.extra(window.nkGifts.state(), item).concat(body.items);
      withGifts = body.items.length > 1;
    }
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    try {
      if (btn.dataset.nxcRemove) {
        var updates = {};
        btn.dataset.nxcRemove.split(',').forEach(function (k) { updates[k] = 0; });
        var r0 = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
        if (!r0.ok) throw new Error('error');
      }
      var res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      var data = await res.json();
      if ((!res.ok || data.status) && withGifts) {
        body.items = [item];
        res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        data = await res.json();
      }
      if (!res.ok || data.status) throw new Error(data.description || 'error');
      if (drawer && data.sections) {
        drawer.renderContents(Object.assign({}, (data.items && data.items[0]) || {}, { sections: data.sections }));
      } else {
        window.location.href = root + 'cart';
      }
    } catch (err) {
      window.location.reload();
    }
  });
})();

/* ---------- Nattokinase free gifts ----------
   The gifts are priced products that automatic Buy X Get Y discounts make free at checkout. After every cart change this works out which gifts the Nattokinase lines earn
   and adds or removes them, so the cart and checkout always hold exactly the right gifts.
   Rules (keep GIFT_RULES in assets/nk-buybox.js in step):
     One-time   3+ bottles: Circulation Log            6+: Log + Morning Flow Routine
     Subscribe  1+ bottle:  Log + Pill Organizer       3+: Magnesium + Log + Routine + Organizer
                6+:         2 Magnesium + Log + Routine + Organizer                                  */
(function () {
  if (window.nkGifts) return;
  var NATTO = 67867834777662;
  var GIFT = { mag: 67902369497150, org: 67902369529918, log: 67902369562686, routine: 67902369595454 };
  var IDS = Object.keys(GIFT).map(function (k) { return GIFT[k]; });
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var rawFetch = window.fetch.bind(window);
  var drawer = function () { return document.querySelector('cart-drawer'); };
  var running = null;
  var again = false;
  var timer;
  var last = null; // the latest full cart Shopify sent back
  function remember(cart) { if (cart && cart.items && typeof cart.item_count === 'number') last = cart; }

  function earned(one, sub) {
    var w = { mag: 0, org: 0, log: 0, routine: 0 };
    if (one >= 3) w.log = 1;
    if (one >= 6) w.routine = 1;
    if (sub >= 1) { w.log = 1; w.org = 1; }
    if (sub >= 3) { w.mag = 1; w.routine = 1; }
    if (sub >= 6) w.mag = 2;
    return w;
  }

  function tally(cart) {
    var t = { one: 0, sub: 0, have: {} };
    cart.items.forEach(function (it) {
      if (it.variant_id === NATTO) {
        if (it.selling_plan_allocation) t.sub += it.quantity; else t.one += it.quantity;
      } else if (IDS.indexOf(it.variant_id) > -1) {
        t.have[it.variant_id] = (t.have[it.variant_id] || 0) + it.quantity;
      }
    });
    return t;
  }

  // Gifts to add alongside an add-to-cart line, so bottles and gifts go in with one request.
  function extra(cart, add) {
    var t = tally(cart);
    if (add && Number(add.id) === NATTO) {
      if (add.selling_plan) t.sub += Number(add.quantity) || 1; else t.one += Number(add.quantity) || 1;
    }
    var want = earned(t.one, t.sub), out = [];
    Object.keys(GIFT).forEach(function (k) {
      var more = want[k] - (t.have[GIFT[k]] || 0);
      if (more > 0) out.push({ id: GIFT[k], quantity: more });
    });
    return out;
  }

  // Returns the {variantId: quantity} changes the cart needs, or null when it's already right.
  function changes(cart) {
    var t = tally(cart), have = t.have;
    var want = earned(t.one, t.sub), out = {}, any = false;
    Object.keys(GIFT).forEach(function (k) {
      var id = GIFT[k];
      if ((have[id] || 0) !== want[k]) { out[id] = want[k]; any = true; }
    });
    return any ? out : null;
  }

  // Gift changes for a quantity update ({lineKey: qty}) worked out from the last known cart.
  function planFor(updates) {
    if (!last) return null;
    var next = {
      items: last.items.map(function (it) {
        var q = Object.prototype.hasOwnProperty.call(updates, it.key) ? Number(updates[it.key]) : it.quantity;
        return { variant_id: it.variant_id, quantity: q, selling_plan_allocation: it.selling_plan_allocation };
      })
    };
    return changes(next);
  }

  function setBusy(on) {
    var d = drawer();
    document.querySelectorAll('main [name="checkout"], #checkout').forEach(function (b) { b.disabled = on; });
    if (!d) return;
    d.classList.toggle('nk-gift-syncing', on);
    var checkout = d.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled = on || d.classList.contains('tx-cart-syncing');
  }

  // Redraw the drawer without forcing it open (Dawn's renderContents always opens it).
  function paint(d, sections, count, open) {
    if (!d || !sections || !d.getSectionsToRender) return false;
    d.getSectionsToRender().forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!el || sections[s.id] == null) return;
      el.innerHTML = d.getSectionInnerHTML(sections[s.id], s.selector);
    });
    d.classList.toggle('is-empty', count === 0);
    var inner = d.querySelector('.drawer__inner');
    if (inner && count > 0) inner.classList.remove('is-empty');
    d.classList.remove('tx-cart-loading');
    var overlay = d.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', d.close.bind(d));
    if (open && typeof d.open === 'function' && !d.classList.contains('active')) d.open();
    return true;
  }

  async function run(opts) {
    setBusy(true);
    try {
      var cart = await (await rawFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      remember(cart);
      var updates = changes(cart);
      var d = drawer();
      var ids = d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
      if (updates) {
        var body = { updates: updates };
        if (ids.length) { body.sections = ids; body.sections_url = window.location.pathname; }
        var res = await rawFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || 'Gift update failed');
        remember(data);
        paint(d, data.sections, data.item_count, opts.open);
        if (/\/cart\/?$/.test(window.location.pathname)) {
          var lastReload = 0;
          try { lastReload = Number(sessionStorage.getItem('nkGiftReload')) || 0; sessionStorage.setItem('nkGiftReload', String(Date.now())); } catch (e) {}
          if (Date.now() - lastReload > 10000) { window.location.reload(); return; }
        }
      } else if (opts.open && ids.length) {
        var sec = await (await rawFetch(window.location.pathname + '?sections=' + ids.join(','))).json();
        paint(d, sec, cart.item_count, true);
      }
    } finally {
      setBusy(false);
    }
  }

  // One run at a time; a change that lands mid-run triggers one more pass.
  function sync(opts) {
    opts = opts || {};
    if (running) {
      again = true;
      if (opts.open) again = 'open';
      return running;
    }
    running = run(opts).catch(function (e) { if (window.console) console.warn('[nk gifts]', e); }).then(function () {
      running = null;
      if (again) { var o = again === 'open'; again = false; return sync({ open: o }); }
    });
    return running;
  }

  function schedule() {
    clearTimeout(timer);
    setBusy(true);
    timer = setTimeout(function () { sync({}); }, 200);
  }

  // Watch every cart change made on the page (drawer buttons, upsells, theme forms) and re-check the gifts.
  // update/change replies carry the whole cart, so most changes are checked without another request.
  // Does an /cart/add body include Nattokinase or a gift? Unreadable bodies count as yes.
  function touchesNatto(body) {
    try {
      var ids = [];
      if (!body) return true;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        ids = body.getAll('id').concat(body.getAll('items[][id]'));
      } else if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body);
          ids = (j.items || []).map(function (it) { return it.id; });
          if (j.id) ids.push(j.id);
        } else {
          return /67867834777662|6790236/.test(body);
        }
      } else {
        return true;
      }
      return ids.some(function (id) { id = Number(id); return id === NATTO || IDS.indexOf(id) > -1; });
    } catch (e) { return true; }
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var skip = false;
    if (init && init.headers) skip = init.headers instanceof Headers ? !!init.headers.get('X-NK-Gift') : !!init.headers['X-NK-Gift'];
    var p = rawFetch(input, init);
    if (/\/cart\/(add|update|change|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) {
        if (!r.ok) return;
        if (/\/cart\/(update|change)/.test(url)) {
          r.clone().json().then(function (cart) {
            remember(cart);
            if (!skip && changes(cart)) schedule();
          }).catch(function () { if (!skip) schedule(); });
        } else if (!skip && (!/\/cart\/add/.test(url) || touchesNatto(init && init.body))) {
          schedule();
        }
      }).catch(function () {});
    }
    return p;
  };

  // Apps that change the cart with XMLHttpRequest instead of fetch.
  if (window.XMLHttpRequest) {
    var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__nkUrl = String(u || ''); return xOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      var x = this;
      if (/\/cart\/(add|update|change|clear)(\.js)?(\?|$)/.test(x.__nkUrl || '')) {
        x.addEventListener('load', function () {
          if (x.status >= 200 && x.status < 300 && (!/\/cart\/add/.test(x.__nkUrl) || touchesNatto(body))) schedule();
        });
      }
      return xSend.apply(this, arguments);
    };
  }

  window.nkGifts = { sync: sync, earned: earned, extra: extra, paint: paint, planFor: planFor, state: function () { return last; } };

  // Fix a cart left in a wrong state (e.g. changed in another tab) as soon as the page loads.
  function boot() {
    var d = drawer();
    if (d && !d.classList.contains('is-empty')) sync({});
    else if (d) last = { items: [], item_count: 0 };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
